export const STORE_TYPE = {
  PHYSICAL: "PHYSICAL",
  MOBILE: "MOBILE",
} as const

export type StoreType = (typeof STORE_TYPE)[keyof typeof STORE_TYPE]
